import Axios from 'axios'

export default {
    namespaced: true,

    state: {
        token: null,
        user: null,
    },
    getters: {
        authenticated(state) {
            return state.token && state.user
        },
        user(state) {
            // console.log('sdfsdf')
            // console.log(state)
            return state.user
        },
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
            console.log(state.token)
        },
        SET_USER(state, data) {
            state.user = data
        },
    },
    actions: {
        async signIn({dispatch}, credentials) {
            //  console.log(credentials)
            let response = await Axios.post('auth/login', credentials)
          console.log(response.data)
            dispatch('attempt', response.data.token)
        },

        async attempt({commit, state}, token) {
            //console.log(token)
            if (token) {
                console.log('laalala')
                commit('SET_TOKEN', token)
                console.log('babababa')
            }
            
            if (!state.token) {
                return
            }

            try {
                // console.log('as')
                let response = await Axios.get('auth/me')
                commit('SET_USER', response.data.userData) //FI ERROR HENA
            } catch (error) {
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
            }
        },
        SignOut({commit}) {
            return Axios.get('auth/logout').then(() => {
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
            })
        }
    }

}
